import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CheckSendOCRDataService } from './api-services/check-send-ocr-data.service';
import { SendOCRDataService } from './api-services/send-ocr-data.service';
import { UpdateMailAddressService } from './api-services/update-mail-address.service';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW2200Component } from './kymw2200.component';

/**
 * ＯＣＲﾃﾞｰﾀﾒｰﾙ送信画面 モジュール設定クラス
 *
 * @export SampleWindowModule
 * @class SampleWindowModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW2200Component,
  ],
  providers: [
    UpdateMailAddressService,
    SendOCRDataService,
    CheckSendOCRDataService,
  ],
})
export class KYMW2200Module {

}
